import { BASE_API } from "../utils/constants";
import { authHeader } from "./token";

// Ambientes del local (Salón, Terraza, Piso 2…): las mesas del salón pertenecen
// a uno y se numeran dentro de él. Ver tables/models.py → Area.
async function request(path, token, options = {}) {
  const response = await fetch(`${BASE_API}/api/areas/${path}`, {
    ...options,
    headers: {
      ...authHeader(token),
      ...(options.body ? { "Content-Type": "application/json" } : {}),
    },
  });
  if (response.status === 204) return null;
  const result = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(firstError(result) || "No se pudo guardar el ambiente");
  return result;
}

export function firstError(result) {
  if (!result || typeof result !== "object") return "";
  if (result.detail) return result.detail;
  const first = Object.values(result)[0];
  return Array.isArray(first) ? first[0] : first || "";
}

export const getAreasApi = (token) => request("", token);
export const addAreaApi = (data, token) =>
  request("", token, { method: "POST", body: JSON.stringify(data) });
export const updateAreaApi = (id, data, token) =>
  request(`${id}/`, token, { method: "PATCH", body: JSON.stringify(data) });
export const deleteAreaApi = (id, token) => request(`${id}/`, token, { method: "DELETE" });
